import { render, staticRenderFns } from "./jiaodui.vue?vue&type=template&id=4dea9e74&scoped=true&"
import script from "./jiaodui.vue?vue&type=script&lang=js&"
export * from "./jiaodui.vue?vue&type=script&lang=js&"
import style0 from "./jiaodui.vue?vue&type=style&index=0&id=4dea9e74&lang=scss&scoped=true&"
import style1 from "./jiaodui.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea9e74",
  null
  
)

export default component.exports